import styled from "styled-components";
import { theme } from '../../../../theme'
import {
    MdCropOriginal
} from "react-icons/md";

import { MoreVert } from "@material-ui/icons"
import { IconButton } from "@material-ui/core";


const Item = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
//   padding-left: 1.6rem;
    padding: 1.5rem 0;
    border-bottom: 1px solid rgb(216 216 216 / 37%);
`

const ImageContainer = styled.div`
    width: 3.5rem;
    height: 3.5rem;
    color: ${theme.colors.mainBlue};
    background: rgba(33, 150, 243, 0.44);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
        height: 2.4rem;
        width: 2.4rem;
    }
`

const TextContainer = styled.div`
    .main-header {
        font-weight: 600;
        font-size: 1.4rem;
        color: #3B3B42;
    }
    .sub-header {
        font-size: 1.2rem;
        color: #979797;
    }
    .time {
        font-size: 0.9rem;
        color: #979797;
    }
`

const RecentActivityItem = () => {
    return (
        <Item>
            <ImageContainer>
                <MdCropOriginal />
            </ImageContainer>
            <TextContainer>
                <p className="main-header">Profile picture updated</p>
                <p className="sub-header">You updated your profile picture</p>
                <p className="time">2 hours ago</p>
            </TextContainer>
            <div>
                <IconButton aria-label="settings">
                    <MoreVert />
                </IconButton>
            </div>
        </Item>
    )
}

export default RecentActivityItem
